import { PriceDto } from 'gleblu-socket-api';

import { Price } from '../interfaces/Price';

export function fromDto(priceDto: PriceDto): Price {
  return {
    id: priceDto.id,
    currency: priceDto.currency,
    productId: priceDto.productId,
    unitAmount: priceDto.unitAmount,
    interval: priceDto.interval,
    archived: priceDto.archived,
    trialAvailable: priceDto.trialAvailable,
  };
}
